export const environment = {
    production: false,
    redirectUri: 'https://cardio4citiesdev.novartis.net',
    apiUrl: '/api',
    apiKey: '',
    handshakeToken: 'Cis5SvxI78CTT6UGKZ5q-x1ZQ-Uh35HpnjLRRL0X23s',
    api: {
        baseUrl: '/api',
        runPostPath: '/simulation',
        mode: 'local' // keep as is for now
    },
    enableMeValidation: true,

    b2cTenant: 'ciamtest01.onmicrosoft.com',
    b2cDomain: 'ciamtest01.b2clogin.com',
    b2cClientId: 'a39cf234-2e8b-4178-895e-2e13aae41d99',
    b2cSignUpSignInPolicy: 'B2C_1_Signup_signin_Cardio4CitiesDev',
};